import React, { useEffect, useState } from "react";

import { Button, Form, FormGroup, FormLabel } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { Field, Formik, FormikProvider, useFormik } from "formik";
import Building from "../../Services/buildingService";
import { ErrorAlert } from "../../Components/ErrorAlert";

function AddBuilding(props) {
  const { edit } = props;

  const buildingId = useParams().id;

  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  const getBuildingEdit = async () => {
    if (edit && buildingId) {
      setLoading(true);
      await Building.getOne(buildingId)
        .then((data) => {
          const building = data.data.data;
          setFieldValue("name", building.name);
          setFieldValue("email", building.email);
          setFieldValue("code", building.code);
          setFieldValue("rent_unit_price", building.rent_unit_price);
          setFieldValue("location", building.location);
          setFieldValue("phone", building.phone);
          setLoading(false);
        })
        .catch((err) => {
          setError(true);
          setLoading(false);
          console.log(err);
        });
    }
  };

  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      code: "",
      phone: "",
      rent_unit_price: "",
      location: "",
    },
    onSubmit: (values, { setSubmitting, setFieldError }) => {
      console.log(values);
      if (edit) {
        Building.update(values, buildingId)
          .then((data) => {
            navigate("/buildings-list");
            console.log(data);
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        Building.add(values)
          .then((data) => {
            navigate("/buildings-list");
            console.log(data);
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
  });
  const {
    errors,
    touched,
    isSubmitting,
    getFieldProps,
    handleSubmit,
    setFieldValue,
    handleChange,
  } = formik;

  useEffect(() => {
    // getShopKeepers();
    getBuildingEdit();
  }, []);
  return (
    <>
      {loading && (
        <div id="global-loader">
          <div class="whirly-loader"> </div>
        </div>
      )}
      <div class="page-wrapper">
        <div class="content">
          <div class="page-header">
            <div class="page-title">
              <h4>Building Management</h4>
              <h6>Add/Update Building</h6>
            </div>
          </div>

          <div class="card">
            <div class="card-body">
              {!error && (
                <FormikProvider value={formik}>
                  <Form autoComplete="off" onSubmit={handleSubmit}>
                    <FormGroup class="mb-3">
                      <div class="row">
                        <div class="col-lg-3 col-sm-6 col-12">
                          <div class="form-group">
                            <FormLabel>Building Name</FormLabel>
                            <Field type="text" name="name" required />
                          </div>
                        </div>
                        <div class="col-lg-3 col-sm-6 col-12">
                          <div class="form-group">
                            <FormLabel>Building Code</FormLabel>
                            <Field type="text" name="code" required />
                          </div>
                        </div>
                        <div class="col-lg-3 col-sm-6 col-12">
                          <div class="form-group">
                            <FormLabel>Email</FormLabel>
                            <Field type="email" name="email" required />
                          </div>
                        </div>
                        <div class="col-lg-3 col-sm-6 col-12">
                          <div class="form-group">
                            <FormLabel>Rent</FormLabel>
                            <Field
                              type="text"
                              name="rent_unit_price"
                              required
                            />
                          </div>
                        </div>
                        <div class="col-lg-3 col-sm-6 col-12">
                          <div class="form-group">
                            <FormLabel>Location</FormLabel>
                            <Field type="text" name="location" required />
                          </div>
                        </div>
                        <div class="col-lg-3 col-sm-6 col-12">
                          <div class="form-group">
                            <FormLabel>Phone</FormLabel>
                            <Field
                              type="text"
                              name="phone"
                              pattern="^((\+92))(3)([0-9]{9})$"
                              placeholder="+920000000"
                              required
                            />
                          </div>
                        </div>
                        <div class="col-lg-12">
                          <Button className="btn btn-submit me-2" type="submit">
                            Submit
                          </Button>
                          <a href="building-list" class="btn btn-cancel">
                            Cancel
                          </a>
                        </div>
                      </div>
                    </FormGroup>
                  </Form>
                </FormikProvider>
              )}
              {error && <ErrorAlert heading={"Shop not found"}></ErrorAlert>}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddBuilding;
